import React from 'react';
import { Card, CardContent, Typography, Chip } from '@mui/material';

export default function KpiCard({ title, value, color = 'primary' }) {
  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle2">{title}</Typography>
        <Chip label={value} color={color} />
      </CardContent>
    </Card>
  );
}